import { Axios } from "@/utils/axios";

export const getJangjiRecommendRequests = async () => {
  const { data } = await Axios.get(`/jangji_recommend_requests/`);
  return data;
};

/**
 * 장지 추천 요청서 부분 수정. 지금은 여유 설문 답변을 남기는 데만 쓴다.
 *
 * **`memo` 에는 선택지 원문만 보낸다.** 기존 memo 와 합치는 것은 서버 몫이다
 * (`append_jangji_survey_memo`). 합친 문자열을 보내도 서버가 받아주지만
 * (`incoming.startswith(existing)` 분기) 그건 하위호환용이고, 추천 견적처럼
 * memo 가 빈 값이면 앞 공백이 그대로 저장된다.
 *
 * 서버는 이미 마커가 있으면 무시한다. 재제출은 멱등이다.
 *
 * 조회 응답(`JangjiRecommendRequestSerializer`)의 `id` 를 pk 로 쓴다. 2026-09-03 dev
 * 배포로 `id` 가 내려온다. 계약은 mumflower `wiki/api/jangji-recommend-request.md`.
 */
export const patchJangjiRecommendRequest = async (id: number, body: { memo: string }) => {
  const { data } = await Axios.patch(`/jangji_recommend_requests/${id}/`, body);
  return data;
};

/**
 * 장지 여유 고객의 상담 희망 시간 저장 (요청서 1:1 upsert).
 *
 * 고객이 고르는 것은 "몇 시에 전화해달라" 는 시각뿐이고 **날짜는 서버가 정한다.**
 * 21시 이후면 익일, 08시 이전이면 당일, 금 21:00~월 08:00 이면 다음 월요일이다
 * (`resolve_slot_date`). 그래서 주말이어도 body 는 평일과 같다.
 *
 * 허용 슬롯은 09-12, 13-17 뿐이고 점심 12-13 은 없다. 그 밖의 값은 400 이다.
 * 다시 고르면 같은 주소로 보낸다. 서버가 같은 행을 덮어쓰고 알림톡 상태를 pending 으로
 * 되돌린다.
 *
 * 응답은 201 이고 body 가 없다. 저장된 시간은 조회 응답에 안 실리므로, 새로고침 후에는
 * 프론트가 선택 여부를 알 수 없다. 재선택이 허용되니 데이터는 안전하다.
 *
 * 계약은 mumflower `wiki/api/jangji-consult-time.md`.
 */
export const patchJangjiRecommendRequestConsultTime = async (
  id: number,
  body: { start: string; end: string }, // "09:00", "10:00"
) => {
  return Axios.patch(`/jangji_recommend_requests/${id}/consult-time/`, body);
};
